export const tr = {
    clients: 'Müşteriler',
    currency: 'Para birimi',
    name: 'İsim',
    period: 'Dönem',
    'price-context': 'CPM',
    'shows-max': 'Gösterimler, maks.',
    'shows-min': 'Gösterimler, min.',
    status: 'Durum',
    targetings: 'Hedeflemeler'
};
